export default __webpack_public_path__ + "static/media/Phone1.0fd57718.png";